const a=()=>window.matchMedia("(max-width: 480px)").matches;export{a as default};
//# sourceMappingURL=isScreenSmall.js.map
